/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Swimming_PoolInputs */

const en_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Pool?`)
};

const es_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Piscina privada?`)
};

const fr_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piscine privée ?`)
};

const de_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privater Pool?`)
};

const ja_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライベートプールの有無`)
};

const zh_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私人泳池？`)
};

const ar_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسبح خاص؟`)
};

const id_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolam Renang Pribadi?`)
};

const it_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piscina Privata?`)
};

const ru_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Собственный бассейн?`)
};

const pt_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piscina Privada?`)
};

const ko_field_swimming_pool = /** @type {(inputs: Field_Swimming_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프라이빗 풀 여부`)
};

/**
* | output |
* | --- |
* | "Private Pool?" |
*
* @param {Field_Swimming_PoolInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_swimming_pool = /** @type {((inputs?: Field_Swimming_PoolInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Swimming_PoolInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_swimming_pool(inputs)
	if (locale === "es") return es_field_swimming_pool(inputs)
	if (locale === "fr") return fr_field_swimming_pool(inputs)
	if (locale === "de") return de_field_swimming_pool(inputs)
	if (locale === "ja") return ja_field_swimming_pool(inputs)
	if (locale === "zh") return zh_field_swimming_pool(inputs)
	if (locale === "ar") return ar_field_swimming_pool(inputs)
	if (locale === "id") return id_field_swimming_pool(inputs)
	if (locale === "it") return it_field_swimming_pool(inputs)
	if (locale === "ru") return ru_field_swimming_pool(inputs)
	if (locale === "pt") return pt_field_swimming_pool(inputs)
	return ko_field_swimming_pool(inputs)
});